import { render, staticRenderFns } from "./invoiceListVat.vue?vue&type=template&id=040d689d&scoped=true&"
import script from "./invoiceListVat.vue?vue&type=script&lang=js&"
export * from "./invoiceListVat.vue?vue&type=script&lang=js&"
import style0 from "./invoiceListVat.vue?vue&type=style&index=0&id=040d689d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d689d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
